import { Outlet, useRouteLoaderData } from "react-router";
import { Header, type HeaderExtras } from "~/components/Header";
import { Footer } from "~/components/Footer";
import { EventType } from "~/__generated__/graphql/graphql";
import { useRootLocale } from "~/root";
import { formatLocalizedDate } from "~/utils/date";
import type { loader } from "./plans.$eventId/route";
import { isTicketSalesAwaitingApproval } from "./plans.$eventId/ticketSalesAvailability";

export default function PlansLayout() {
  const data = useRouteLoaderData<typeof loader>("routes/plans.$eventId");
  const plan = data?.plan;
  const locale = useRootLocale();
  let indicatorTone: HeaderExtras["indicatorTone"] = "pink";
  if (plan && (plan.canceled || plan.hasEnded || isTicketSalesAwaitingApproval(plan))) {
    indicatorTone = "muted";
  } else if (plan?.isAttending) {
    indicatorTone = "green";
  } else if (plan?.type === EventType.Ticketed && !plan.isPublished) {
    indicatorTone = "muted";
  }

  const extras: HeaderExtras | undefined = plan ? {
    primaryLabel: plan.title,
    secondaryLabel: formatLocalizedDate(plan.startDate, "eventDate", locale),
    indicatorTone,
    revealCenterOnScroll: true,
    share: { url: `https://app.joinbutter.co/plans/${plan.id}` },
  } : undefined;

  return (
    <div className="butter-grain relative min-h-screen flex flex-col items-center text-base bg-butter-cream-light text-butter-green font-sans">
      <div className="relative z-10 w-full flex flex-col items-center">
        <Header extras={extras} />

        <div className="w-full flex flex-col items-center px-5 pt-5 lg:pt-10">
          <Outlet />
        </div>

        <div className="w-full flex flex-col items-center px-5">
          <Footer />
        </div>
      </div>
    </div>
  );
}
